import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const PromoteInstallmentsModalToggle = ({ onClick  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("button", {
        className: "tooltip__button",
        "aria-label": getLabel('common.tooltip'),
        "data-t": "tooltip-button",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "questionmark"
    }));
};

export { PromoteInstallmentsModalToggle };
//# sourceMappingURL=PromoteInstallmentsModalToggle.js.map
